import React, { useContext, useEffect } from "react"
import hotkeys from "hotkeys-js"

import SearchContext from "~contexts/SearchContext"

import { FiSearch } from "react-icons/fi"
import Search from "~components/Search"
import * as style from "./Header.module.scss"

const SearchBar = ({ microcopy }) => {
  const engine = useContext(SearchContext)

  useEffect(() => engine.showButton(), [])

  useEffect(() => {
    hotkeys("/", (event) => {
      event.preventDefault()
      if (!engine.state.showSearch) event.preventDefault()
      engine.toggle()
    })

    hotkeys("esc", (event) => {
      event.preventDefault()
      engine.hide()
    })
  })

  return (
    <>
      {engine && engine.state.showSearchButton && (
        <a
          className={style.search}
          onClick={() => engine.show()}
          data-role="search"
          role="button"
          aria-label={microcopy.text("search.prompt")}
          data-active={engine.state.showSearch}
        >
          &nbsp;
          <FiSearch />
        </a>
      )}
      {engine && <Search engine={engine} microcopy={microcopy} />}
    </>
  )
}

export default SearchBar
